/* PONYSPEC 5.4 — the year calendar.
   Every year 2019-2026 is openable. "Under construction" belongs to the CLASS,
   not the year: a class still being cut carries its own dashed row and an
   "In the edit" tag, and the year around it stays open. Blocking a whole year
   hid ten finished 2024 classes behind one warning label.

   LINKING RULE (added 23 Aug 2026). A row links to /products/<h> only when it
   also carries u:1 — tickets actually on sale. Handles alone are not enough:
   Shopify products get archived or dropped to draft once a class has run, and
   an archived product 404s. Four 2026 rows (Jan, Feb, Mar, Apr) were shipping
   dead links for exactly that reason, under a footnote that read "Nothing here
   404s." Past classes now render as plain rows carrying their video count, and
   the section CTA sends people to the app. Verified in the browser. */
(function () {
  function boot(root) {
    var raw = root.querySelector('script[data-pony-cal]');
    if (!raw) return;
    var rows;
    try { rows = JSON.parse(raw.textContent); } catch (e) { return; }

    var years = [];
    rows.forEach(function (r) { if (years.indexOf(r.y) === -1) years.push(r.y); });
    years.sort(function (a, b) { return b - a; });

    var tabsEl = root.querySelector('[data-cal-tabs]');
    var bodyEl = root.querySelector('[data-cal-body]');
    var noteEl = root.querySelector('[data-cal-note]');
    var noteClean = root.getAttribute('data-note-clean') || '';
    var noteEdit = root.getAttribute('data-note-edit') || '';
    var active = years[0];

    /* A product link is only safe while the class is on sale. */
    function linkable(r) { return !!(r.h && r.u); }

    function runtime(min) {
      if (!min) return '';
      var h = Math.floor(min / 60), m = min % 60;
      return h ? (h + 'h ' + (m ? m + 'm' : '') ).trim() : m + 'm';
    }

    function countFor(y) {
      var all = rows.filter(function (r) { return r.y === y; });
      return { n: all.length, cut: all.filter(function (r) { return r.c; }).length };
    }

    function drawTabs() {
      tabsEl.innerHTML = '';
      years.forEach(function (y) {
        var c = countFor(y);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pc__yr' + (y === active ? ' is-on' : '');
        b.setAttribute('aria-pressed', y === active ? 'true' : 'false');
        var sub = c.n + (c.n === 1 ? ' class' : ' classes');
        if (c.cut) sub += ' · ' + c.cut + ' in the edit';
        b.innerHTML = '<b>' + y + '</b><span>' + sub + '</span>';
        b.addEventListener('click', function () { active = y; render(); });
        tabsEl.appendChild(b);
      });
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;');
    }

    function drawRows() {
      var list = rows.filter(function (r) { return r.y === active; });
      bodyEl.innerHTML = '';
      list.forEach(function (r) {
        var isLink = linkable(r);
        var el = document.createElement(isLink ? 'a' : 'div');
        el.className = 'pc__row' + (r.c ? ' is-cut' : '');
        if (isLink) el.href = '/products/' + r.h;
        var meta;
        if (r.c) {
          meta = '<em class="pc__tag">In the edit</em>';
        } else if (r.u) {
          meta = '<em class="pc__tag pc__tag--up">Tickets open</em>';
        } else if (r.v) {
          meta = esc(r.v + (r.v === 1 ? ' video' : ' videos') + (r.r ? ' · ' + runtime(r.r) : ''));
        } else {
          meta = '';
        }
        el.innerHTML =
          '<span class="pc__mo">' + esc(r.m) + '</span>' +
          '<span class="pc__ti">' + esc(r.t) + '</span>' +
          '<span class="pc__ed">' + esc(r.e) + '</span>' +
          '<span class="pc__me">' + meta + '</span>';
        bodyEl.appendChild(el);
      });
    }

    function render() {
      drawTabs();
      drawRows();
      if (noteEl) {
        var c = countFor(active);
        noteEl.textContent = c.cut
          ? noteEdit.split('{n}').join(c.cut)
          : noteClean;
      }
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-pony-calendar]').forEach(boot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();